import { clientsApi, dealsApi, optionsApi } from '../utils/api';
import useRemoteOptions from './useRemoteOptions';

const byName = (fallback) => (row) => ({
  value: Number(row.id),
  label: row.name || row.type || `${fallback} #${row.id}`,
  color: row.color,
});

/** منابع گزینه‌های سمت سرور؛ همه با قرارداد { data, pagination: { has_more } } */
export const REMOTE_OPTION_SOURCES = {
  products: { fetcher: optionsApi.products, toOption: byName('محصول'), notFound: 'محصولی یافت نشد' },
  tags: { fetcher: optionsApi.tags, toOption: byName('تگ'), notFound: 'تگی یافت نشد' },
  sources: { fetcher: optionsApi.leadSources, toOption: byName('شیوه آشنایی'), notFound: 'موردی یافت نشد' },
  leads: {
    fetcher: dealsApi.getLeadOptions,
    toOption: (l) => ({ value: Number(l.id), label: l.client_name || l.name || `سرنخ #${l.id}`, mobile: l.mobile }),
    notFound: 'سرنخی یافت نشد',
  },
  clients: {
    fetcher: clientsApi.getOptions,
    toOption: (c) => ({ value: Number(c.id), label: c.name || c.company_name || `مشتری #${c.id}`, mobile: c.mobile }),
    notFound: 'مشتری یافت نشد',
  },
};

/**
 * useRemoteOptions برای یک نوع مشخص: 'products' | 'tags' | 'sources' | 'leads' | 'clients'
 * selectedValue: مقدار(های) انتخاب‌شده تا برچسبشان با ids[] گرفته شود.
 */
export default function useRemoteEntityOptions(kind, { selectedValue, pageSize, extraParams } = {}) {
  const source = REMOTE_OPTION_SOURCES[kind];
  if (!source) throw new Error(`Unknown remote option kind: ${kind}`);
  const remote = useRemoteOptions({
    fetcher: source.fetcher,
    toOption: source.toOption,
    selectedValue,
    pageSize,
    extraParams,
  });
  return {
    ...remote,
    selectProps: {
      ...remote.selectProps,
      notFoundContent: remote.loading ? 'در حال جستجو...' : source.notFound,
    },
  };
}
